import React, { useEffect, useMemo, useRef, useState } from "react";
import { TouchableOpacity, Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import NoDataFound from "../NoDataFound";
import Ionicons from "@expo/vector-icons/Ionicons";
import { FlatList } from "react-native";
import HomeItem from "../../screens/Auth/WebScreens/Common/HomeItem";
import { CommonButton } from "../../common/CommonButton";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { AppScreens } from "../../screens/Utility/AppScreens";
import HomeCardSkeleton from "../skeleton-components/HomeCardSkeleton";

type HomeCardsProps = {
  userData: any;
  heading: string;
  CardData: any;
  CardDataEmpty: any;
  // setIsGetTicket: any;
  accessToken: string;
  popularIndex?: number;
  setPopularIndex?: any;
  userProfileData?: any;
  showLoader?: boolean;
  eventID?: string;
};

const HomeCards: React.FC<HomeCardsProps> = ({
  userData,
  heading,
  CardData,
  CardDataEmpty,
  showLoader = false,
  eventID = "",
  // setIsGetTicket,
  accessToken,
  popularIndex,
  setPopularIndex,
  userProfileData,
}) => {
  const screenName = "Home";
  const navigation = useNavigation();

  const flatListRef = useRef<FlatList<any>>(null);
  const deviceSize = useDeviceSize();

  useEffect(() => {
    if (CardData.length > 0) {
      flatListRef.current?.scrollToIndex({
        index: popularIndex,
        animated: true,
        viewPosition: 0,
      });
    }
  }, [popularIndex]);

  const handleNextPress = () => {
    if (popularIndex === CardData.length - 1) {
      return;
    }
    const newIndex = popularIndex + 1;
    setPopularIndex(newIndex);
    flatListRef.current?.scrollToIndex({ index: newIndex, animated: true });
  };

  const handlePrevPress = () => {
    if (popularIndex === 0) {
      return;
    }
    const newIndex = popularIndex - 1;
    setPopularIndex(newIndex);
    flatListRef.current?.scrollToIndex({ index: newIndex, animated: true });
  };

  const firstGetTicketIndex = useMemo(() => {
    return CardData.findIndex(
      (item) =>
        heading === "Popular Events" &&
        item.type === "Private" &&
        !item.attendeeIDs.includes(userData.username) &&
        !item.participantIDs.includes(userData.username)
    );
  }, [CardData, userData, heading]);

  // Find the first index matching conditions for "Sign-Up"
  const firstSignUpIndex = useMemo(() => {
    return CardData.findIndex(
      (item) =>
        heading === "Popular Events" &&
        item.type !== "Private" &&
        !item.attendeeIDs.includes(userData.username) &&
        !item.participantIDs.includes(userData.username)
    );
  }, [CardData, userData, heading]);

  return (
    <View
      style={{
        paddingVertical: 12,
      }}
    >
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              {
                color: AppColors.white,
                marginTop: 10,
              },
            ]}
          >
            {heading}
          </Text>
        </View>{" "}
        {heading === "Recommended" && CardDataEmpty ? (
          <CommonButton
            title="Set Your Profile"
            onTap={() =>
              navigateToScreen(navigation, AppScreens.ChooseGameLikeScreen, {
                  username: userData.username,
                  flag: 1,
                })
            }
            buttonStyle={{
              paddingVertical: 14,
              backgroundColor: AppColors.themeColor_0A89AD,
              borderRadius: 50,
              shadowOpacity: 0,
              height: 35,
            }}
          />
        ) : null}
      </View>

      {showLoader ? (
        <HomeCardSkeleton />
      ) : (
        <View
          style={{
            flexDirection: "row",
            marginVertical: 14,
            alignSelf: CardDataEmpty ? "center" : "stretch",
            gap: 5,
          }}
        >
          {heading === "Recommended" && CardDataEmpty ? (
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  color: AppColors.white,
                  flex: 1,
                  alignSelf: "center",
                  marginTop: 10,
                  textAlign: "center",
                },
              ]}
            >
              No current events based on your current selected games
            </Text>
          ) : CardDataEmpty ? (
            <NoDataFound />
          ) : (
            <View style={{ flex: 1, flexDirection: "row" }}>
              {deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.XS ? null : (
                <TouchableOpacity
                  activeOpacity={0.5}
                  style={{
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={handlePrevPress}
                >
                  <Ionicons
                    name="arrow-back"
                    size={35}
                    color={AppColors.white}
                  />
                </TouchableOpacity>
              )}
              <FlatList
                horizontal={true}
                data={CardData}
                ref={flatListRef}
                initialScrollIndex={popularIndex}
                showsHorizontalScrollIndicator={false}
                renderItem={({ item, index }) => (
                  <HomeItem
                    firstSignUpIndex={firstSignUpIndex}
                    firstGetTicketIndex={firstGetTicketIndex}
                    heading={heading}
                    userData={userData}
                    eventID={eventID}
                    index={index}
                    item={item}
                    accessToken={accessToken}
                    screenName={screenName}
                    userProfileData={userProfileData}
                    // getTicketTapped={() => {
                    //   setIsGetTicket(true);
                    // }}
                  />
                )}
                ItemSeparatorComponent={() => {
                  return <View style={{ width: 20 }} />;
                }}
              />
              {deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.XS ? null : (
                <TouchableOpacity
                  activeOpacity={0.5}
                  style={{
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={handleNextPress}
                >
                  <Ionicons
                    name="arrow-forward"
                    size={35}
                    color={AppColors.white}
                  />
                </TouchableOpacity>
              )}
            </View>
          )}
        </View>
      )}
    </View>
  );
};

export default HomeCards;
